<template>
  <datepicker
    v-bind="{ ...$attrs, ...$props }"
    class="app-datepicker"
    v-on="$listeners"
  />
</template>

<script>
  import Datepicker from 'vuejs-datepicker';
  import { nl } from 'vuejs-datepicker/dist/locale';

  export default {
    name: 'AppDatepicker',

    components: { Datepicker },

    props: {
      id: {
        type: String,
        default: null,
      },

      language: {
        type: Object,
        default: () => nl,
      },

      inputClass: {
        type: [String, Object],
        default: 'form-control',
      },

      mondayFirst: {
        type: Boolean,
        default: true,
      },

      clearButton: {
        type: Boolean,
        default: true,
      },

      clearButtonIcon: {
        type: String,
        default: 'fa fa-close',
      },
    },
  };
</script>



// WEBPACK FOOTER //
// resources/js/components/AppDatepicker.vue